// =======================================
// REACH NUTRITION KNOWLEDGE DATA
// Bengali / Indian Context (English + বাংলা)
// =======================================


// =====================
// VITAMINS (Detailed)
// =====================

export const vitaminsData = [

  {
    name: "Vitamin A (ভিটামিন এ)",
    dailyRequirement: "600–900 mcg (Adults) | প্রাপ্তবয়স্কদের জন্য ৬০০–৯০০ মাইক্রোগ্রাম",
    function: "Maintains vision, immunity, skin health | দৃষ্টি শক্তি, রোগ প্রতিরোধ ক্ষমতা ও ত্বকের সুরক্ষা বজায় রাখে",
    sources: "Carrot, spinach bhaji, mango, milk | গাজর, পালং শাক, আম, দুধ",
    portionGuide: "1 katori cooked spinach ≈ 470 mcg | ১ বাটি রান্না করা পালং শাক ≈ ৪৭০ মাইক্রোগ্রাম",
    deficiency: "Night blindness, dry skin | রাতকানা, ত্বক শুষ্ক হওয়া",
    excessRisk: "Liver toxicity (supplements excess) | অতিরিক্ত সাপ্লিমেন্টে লিভারের ক্ষতি"
  },

  {
    name: "Vitamin B1 (Thiamine) (ভিটামিন বি১)",
    dailyRequirement: "1.1–1.2 mg | ১.১–১.২ মিলিগ্রাম",
    function: "Energy metabolism & nerve function | শক্তি উৎপাদন ও স্নায়ুর কার্যক্রমে সহায়ক",
    sources: "Red rice, masoor dal, peanuts | লাল চাল, মসুর ডাল, চিনাবাদাম",
    portionGuide: "1 cup red rice ≈ 0.2 mg | ১ কাপ লাল চাল ≈ ০.২ মি.গ্রা.",
    deficiency: "Beriberi, fatigue | বেরিবেরি, ক্লান্তি"
  },

  {
    name: "Vitamin B12 (ভিটামিন বি১২)",
    dailyRequirement: "2.4 mcg | ২.৪ মাইক্রোগ্রাম",
    function: "Red blood cell formation | লোহিত রক্তকণিকা তৈরিতে সহায়ক",
    sources: "Egg, fish, milk | ডিম, মাছ, দুধ",
    portionGuide: "1 egg ≈ 0.6 mcg | ১টি ডিম ≈ ০.৬ মাইক্রোগ্রাম",
    deficiency: "Anemia, nerve damage | রক্তাল্পতা, স্নায়ুর সমস্যা"
  },

  {
    name: "Vitamin C (ভিটামিন সি)",
    dailyRequirement: "75–90 mg | ৭৫–৯০ মিলিগ্রাম",
    function: "Immunity, wound healing, iron absorption | রোগ প্রতিরোধ, ক্ষত নিরাময়, আয়রন শোষণ বৃদ্ধি",
    sources: "Amla, guava, lemon | আমলকি, পেয়ারা, লেবু",
    portionGuide: "1 amla ≈ 60 mg | ১টি আমলকি ≈ ৬০ মি.গ্রা.",
    deficiency: "Bleeding gums | মাড়ি থেকে রক্তপাত"
  },

  {
    name: "Vitamin D (ভিটামিন ডি)",
    dailyRequirement: "600–800 IU | ৬০০–৮০০ আইইউ",
    function: "Bone health | হাড় মজবুত রাখে",
    sources: "Sunlight, fish | রোদ, মাছ",
    portionGuide: "20 minutes sunlight daily | প্রতিদিন ২০ মিনিট রোদে থাকা",
    deficiency: "Weak bones | হাড় দুর্বল হওয়া"
  }

];


// =====================
// MINERALS (Detailed)
// =====================

export const mineralsData = [

  {
    name: "Calcium (ক্যালসিয়াম)",
    dailyRequirement: "1000 mg | ১০০০ মিলিগ্রাম",
    function: "Bone & teeth strength | হাড় ও দাঁত শক্তিশালী করে",
    sources: "Milk, curd, paneer, sesame | দুধ, দই, পনির, তিল",
    portionGuide: "1 cup milk ≈ 300 mg | ১ কাপ দুধ ≈ ৩০০ মি.গ্রা.",
    deficiency: "Osteoporosis | অস্টিওপোরোসিস"
  },

  {
    name: "Iron (আয়রন)",
    dailyRequirement: "17–21 mg (Women) | মহিলাদের জন্য ১৭–২১ মি.গ্রা.",
    function: "Prevents anemia | রক্তাল্পতা প্রতিরোধ করে",
    sources: "Spinach, lentils, jaggery | পালং শাক, ডাল, গুড়",
    portionGuide: "1 katori dal ≈ 3 mg | ১ বাটি ডাল ≈ ৩ মি.গ্রা.",
    deficiency: "Fatigue | দুর্বলতা"
  },

  {
    name: "Potassium (পটাশিয়াম)",
    dailyRequirement: "3500 mg | ৩৫০০ মি.গ্রা.",
    function: "Heart rhythm | হৃদস্পন্দন নিয়ন্ত্রণ",
    sources: "Banana, coconut water | কলা, ডাবের পানি",
    deficiency: "Muscle weakness | পেশী দুর্বলতা"
  }

];


// =====================
// PROTEIN SOURCES
// =====================

export const proteinSources = [

  { 
    food: "Masoor Dal (মসুর ডাল - ১ বাটি)", 
    protein: "7–9g", 
    calories: "120 kcal" 
  },

  { 
    food: "Egg (ডিম - ১টি)", 
    protein: "6g", 
    calories: "70 kcal" 
  },

  { 
    food: "Chicken (মুরগির মাংস ১০০g)", 
    protein: "27g", 
    calories: "165 kcal" 
  },

  { 
    food: "Rohu Fish (রুই মাছ ১০০g)", 
    protein: "20g", 
    calories: "120 kcal" 
  },

  { 
    food: "Paneer (পনির ১০০g)", 
    protein: "18g", 
    calories: "260 kcal" 
  }

];


// =====================
// BALANCED DIET BY AGE
// =====================

export const balancedDietByAge = [

  {
    ageGroup: "8–15 years (৮–১৫ বছর)",
    calories: "1600–2200 kcal",
    focus: "Growth & bone development | বৃদ্ধি ও হাড়ের গঠন",
    proteinNeed: "1g per kg body weight",
    recommendation: "Milk daily, egg, dal, fruits | প্রতিদিন দুধ, ডিম, ডাল, ফল",
    samplePlate: "Rice + dal + egg + sabji | ভাত + ডাল + ডিম + সবজি"
  },

  {
    ageGroup: "16–25 years (১৬–২৫ বছর)",
    calories: "2000–2800 kcal",
    focus: "Energy & muscle building | শক্তি ও পেশী গঠন",
    proteinNeed: "1.2–1.5g per kg",
    recommendation: "Balanced carbs + protein | সুষম কার্বোহাইড্রেট ও প্রোটিন",
    samplePlate: "2 rotis + fish/chicken + salad | ২ রুটি + মাছ/মুরগি + সালাদ"
  },

  {
    ageGroup: "26–45 years (২৬–৪৫ বছর)",
    calories: "1800–2400 kcal",
    focus: "Weight maintenance | ওজন নিয়ন্ত্রণ",
    proteinNeed: "0.8–1g per kg",
    recommendation: "Moderate rice, more vegetables | কম ভাত, বেশি সবজি",
    samplePlate: "Red rice + dal + fish | লাল চাল + ডাল + মাছ"
  },

  {
    ageGroup: "60+ years (৬০ বছরের ঊর্ধ্বে)",
    calories: "1500–1800 kcal",
    focus: "Immunity & digestibility | রোগ প্রতিরোধ ও সহজ পাচন",
    proteinNeed: "1–1.2g per kg",
    recommendation: "Soft khichuri, curd | নরম খিচুড়ি, দই",
    samplePlate: "Khichuri + boiled vegetables | খিচুড়ি + সেদ্ধ সবজি"
  }

];